// Landing pages only (snippets/lp-analytics). One dl_view_item for the featured product, after Elevar's
// dl_user_data; cta_click for [data-lp-cta] and the buy box's Add to Cart. No third-party requests.
;(() => {
  const page = document.querySelector('[data-analytics-page]')
  if (!page || window.lpAnalytics) return
  window.lpAnalytics = true
  const source = page.dataset.analyticsSource

  const view = document.getElementById('lp-analytics-view-item')
  const hasUserData = () => {
    try {
      return [].some.call(window.ElevarDataLayer || [], (e) => e && e.event === 'dl_user_data')
    } catch {
      return false
    }
  }
  const pushView = () => {
    const { currencyCode, list, product } = JSON.parse(view.textContent)
    const id = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`
    window.ElevarDataLayer.push({
      event: 'dl_view_item',
      event_id: id,
      ecommerce: { currencyCode, detail: { actionField: { list, action: 'detail' }, products: [product] } },
    })
  }
  // Elevar needs dl_user_data first: check every 100ms for up to 5s, then push once (or not at all)
  if (view) {
    let tries = 0
    const wait = () => {
      if (hasUserData()) return setTimeout(pushView, 0)
      if (++tries < 50) setTimeout(wait, 100)
    }
    wait()
  }

  // Visible label: skips SVG titles and screen-reader-only text
  const label = (el) => {
    let text = ''
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT)
    while (walker.nextNode()) {
      if (!walker.currentNode.parentElement?.closest('svg, .sr-only, [aria-hidden="true"]')) text += walker.currentNode.data
    }
    return text.replace(/\s+/g, ' ').trim()
  }

  // Window capture: lp-inline-buy (hero) and the buy-box scroll stop clicks before the document. Synthetic clicks
  // (the hero pressing the buy box's Add to Cart, discount replays) and clicks the hero ignores (an add in flight)
  // are skipped, so each user click is one cta_click.
  window.addEventListener(
    'click',
    (event) => {
      if (!event.isTrusted || event.lpBusy) return
      const el = event.target.closest?.(
        '[data-lp-cta], [data-lp-buy-box-scroll], [data-analytics-component="lp_product_detail"] [data-add-to-cart]'
      )
      const events = window.oneskin?.events
      if (!el || !events) return
      const scroll = el.hasAttribute('data-lp-buy-box-scroll')
      const d = el.dataset
      // Scroll triggers are always for the buy box's product
      const p = (scroll ? document.querySelector('[data-lp-buy-box]') : el.closest('[data-lp-product]'))?.dataset || {}
      events.track('cta_click', {
        cta_text: d.lpText || label(el),
        cta_url: el.getAttribute('href') || d.productUrl || p.lpProductUrl,
        cta_type: scroll ? 'scroll_to_buy_box' : d.lpCta || 'add_to_cart',
        product_name: p.lpProduct,
        product_id: p.lpProductId,
        component_name: el.closest('[data-analytics-component]')?.dataset.analyticsComponent,
        source_location: source,
      })
    },
    { capture: true, passive: true }
  )
})()
